<template>
  <v-dialog
    v-model="dialog"
    class="ch-dialog"
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-sitemap fa-fw"></i>
          <span class="title">NEW ADMIN</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">EMAIL *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group form-textarea-group">
                <div class="form-title">DESCRIPTION</div>
                <div class="form-input">
                  <v-text-field
                    v-model="desc"
                    full-width
                    textarea
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">PASSWORD *</div>
                <div class="form-input">
                  <v-text-field
                    class="ch-input-pwd"
                    v-model="password"
                    :rules="passwordRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group" v-if="visibleDomain">
                <div class="form-title">DOMAIN *</div>
                <div class="form-input">
                  <v-select
                    :items="domainItems"
                    v-model="domain"
                    :rules="domainRules"
                    full-width
                    single-line
                    autocomplete
                    content-class="create-autocomplete-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createAdmin"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  import { adminsEventBus } from '@/components/admin/admins/adminsEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        id: null,
        email: null,
        password: null,
        name: null,
        desc: null,
        api_key: null,
        domainList: null,
        domain: '',
        domainItems: [],
        visibleDomain: false,
        created_at: null,
        updated_at: null,
        // NOTE: Dialog
        createDialog: false,
        deleteDialog: false,
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        passwordRules: [
          v => (v === 0) || !!v || 'Please input Password',
        ],
        domainRules: [
          v => (v === 0) || !!v || 'Please input Domain',
        ],
      };
    },
    methods: {
      createAdmin() {
        // NOTE: 수정 가능한 데이터만 전송
        const params = {
          name: this.name,
          email: this.email,
          desc: this.desc,
          password: this.password,
          domain_id: this.getDomainId(),
        };
        api.createAdmin(params)
        .then((result) => {
          if (result.status === 200) {
            this.createDialog = false;
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            adminsEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getDomainList() {
        api.getDomainList()
        .then((result) => {
          if (result.status === 200) {
            this.domainList = result.data;
            this.domainItems = _.map(result.data, 'name');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getDomainId() {
        if (localStorage.getItem('domain_type') === 'root') {
          return [this.domainList[_.findIndex(this.domainList, { name: this.domain })].id];
        }

        return localStorage.getItem('domain_id');
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      openCreateDialog() {
        this.createDialog = true;
      },
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
    },
    mounted() {
      adminsEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.getDomainList();
        this.visibleDomain = true;
      }
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admins/CreateAdmin.vue